import { render, staticRenderFns } from "./allJob.vue?vue&type=template&id=b235bd34"
import script from "./allJob.vue?vue&type=script&lang=js"
export * from "./allJob.vue?vue&type=script&lang=js"
import style0 from "./allJob.vue?vue&type=style&index=0&id=b235bd34&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports